<template>
  <div class="radio-button__container">
    <div class="radio-group">
      <label
        v-for="(option, i) in options"
        :key="`${option.value}-${i}`"
        :class="{
          'is-disabled': disabled,
          'is-selected': model === option.value,
        }"
      >
        <input
          type="radio"
          v-model="model"
          :value="option.value"
          :disabled="disabled"
          :class="{ 'is-disabled': disabled }"
        />
        <div class="label-text__container" v-html="option.label"></div>
      </label>
    </div>
    <div v-if="hasError" class="radio-button-error__container">
      <Error :message="errorMessage" class="no-border" />
    </div>
  </div>
</template>

<script>
import Error from '@/components/common/Error';

export default {
  name: 'CustomRadioButtonGroup',
  components: {
    Error,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    model: '',
  }),
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        this.model = newValue;
      },
    },
    model: {
      handler(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};
</script>

<style scoped>
.radio-button__container {
  display: flex;
  flex-direction: column;
}

.radio-button-error__container {
  display: flex;
  justify-content: end;
}

.radio-group {
  display: flex;
  justify-content: end;
  flex: 1;
  color: #aab7b1;
}

.label-text__container {
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  padding: 0 10px;
}

.is-disabled {
  cursor: not-allowed !important;
}

.radio-group label {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 60px;
  max-width: 140px;
  min-width: 90px;
  margin: 0 10px;
  line-height: 1;
  text-align: center;
  justify-content: end;
  background-color: #f2f2f2;
  border-radius: 4px 4px 0 0;
  transition: background-color 0.2s ease;
}

.radio-group label.is-selected {
  background-color: #2db782;
  color: #ffffff;
}

.radio-group input[type='radio'] {
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  border: 2px solid #aab7b1;
  border-radius: 50%;
  position: relative;
  background-color: transparent;
  transition: all 0.2s ease;
}

.radio-group input[type='radio']::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: none;
}

.radio-group input[type='radio']:checked {
  border-color: #ffffff;
  background-color: transparent;
}

.radio-group input[type='radio']:checked::before {
  content: '✓';
  display: block;
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  line-height: 1;
}
</style>
